const firebaseProject = import.meta.env.FIREBASE_PROJECT;

export const environment = firebaseProject?.split("-").slice(-1)[0];

export const isProduction = environment === "prod";

export const isStaging = environment === "stag";
